export const decisionFieldsMarkedAsRequired: string[] = [
  'knoOrganization',
  'kindControl',
  'kind',
  'reasons[{id}].type',
  'reasons[{id}].riskIndicators',
  'reasons[{id}].riskIndicators[{id}].riskIndicator',
  'reasons[{id}].riskIndicators[{id}].indicatorRiskAttachment',
  'reasons[{id}].riskIndicators[{id}].indicatorRiskAuto',
  'reasons[{id}].text',
  'reasons[{id}].dateRequirement',
  'reasons[{id}].requirementDetails',
  'reasons[{id}].order',
  'reasons[{id}].links',
  'reasons[{id}].links[{id}].erpId',
  'reasons[{id}].date',
  'reasons[{id}].lastConductedKnmDate',
  'reasons[{id}].assignmentDate',
  'reasons[{id}].assignmentNumber',
  'reasons[{id}].fullName',
  'reasons[{id}].programNumber',
  'reasons[{id}].programAttachment',
  'reasons[{id}].prosecutorAttachment',
  'reasons[{id}].prescriptionDate',
  'reasons[{id}].prescriptionNumber',
  'events',
  'events[{id}].type',
  'events[{id}].interactionCategory',
  'events[{id}].startDate',
  'events[{id}].stopDate',
  'events[{id}].submittedDocuments[{id}].documentTitle',
  'events[{id}].submittedDocuments[{id}].requestDateTime',
  'events[{id}].submittedDocuments[{id}].submissionDeadline',
  'events[{id}].submittedDocuments[{id}].submissionDateTime',
  'events[{id}].submittedDocuments[{id}].files',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].repeatCorrected',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type[{id}].value',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments[{id}].link.value',
  'organization.act.holdingDateTime',
  'organization.act.durationDays',
  'organization.act.durationHours',
  'organization.act.knoInspectors',
  'organization.act.knoInspectors[{id}].knoInspector',
  'organization.act.isViolatedMandatoryRequirements',
  'organization.act.violatedMandatoryRequirements',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].category',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].title',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].descriptionReactQuillEditor',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].repeatCorrected',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].repeatCorrectedInEvent',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type[{id}].value',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'organization.act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments[{id}].link.value',
  'organization.act.fioAndPositionSinger',
  'organization.act.familiarizationNotifications[{id}].knmNoticeType',
  'organization.act.familiarizationNotifications[{id}].noticeDate',
  'organization.act.remarks[{id}].text',
  'organization.act.remarks[{id}].textReactQuillEditor',
  'organization.act.remarks[{id}].signerFullName',
  'organization.act.remarks[{id}].signerPosition',
  'organization.act.remarks[{id}].date',
  'organization.act.isViolationEvidenceExists',
  'organization.act.violationEvidences',
  'organization.act.violationEvidences[{id}].date',
  'organization.act.violationEvidences[{id}].link',
  'organization.act.violationEvidences[{id}].description',
  'organization.act.events',
  'organization.act.events[{id}].type',
  'organization.act.events[{id}].startDate',
  'organization.act.events[{id}].stopDate',
  'organization.act.events[{id}].linkVks',
  'organization.act.events[{id}].inspectors',
  'organization.act.events[{id}].inspectors[{id}].fullName',
  'organization.act.events[{id}].protocol.file.attachments',
  'organization.resultDecisions[{id}].kind',
  'organization.resultDecisions[{id}].injunction.note',
  'organization.resultDecisions[{id}].injunction.noteReactQuillEditor',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethodsRequired',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanationsRequired',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates[{id}].value',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].title',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'organization.resultDecisions[{id}].fioSigner',
  'organization.resultDecisions[{id}].titleSigner',
  'organization.resultDecisions[{id}].founder.inn',
  'organization.resultDecisions[{id}].founder.snils',
  'organization.resultDecisions[{id}].founder.organizationType',
  'organization.resultDecisions[{id}].founder.originalName',
  'organization.resultDecisions[{id}].founder.country',
  'organization.resultDecisions[{id}].founder.rafpNza',
  'organization.resultDecisions[{id}].founder.kpp',
  'organization.resultDecisions[{id}].founder.document',
  'agreements[{id}].prescription',
  'agreements[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type[{id}].value',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments[{id}].link.value',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].grade',
  'agreements[{id}].petitionOrganizationType',
  'agreements[{id}].petitionAttachment',
  'agreements[{id}].petitionOrganization.inn',
  'agreements[{id}].petitionOrganization.ogrn',
  'agreements[{id}].petitionOrganization.snils',
  'agreements[{id}].petitionOrganization.subjectType',
  'agreements[{id}].petitionOrganization.organizationName',
  'agreements[{id}].petitionOrganization.factualAddress',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].petitionOrganization.country',
  'agreements[{id}].petitionOrganization.rafpNza',
  'agreements[{id}].petitionOrganization.kpp',
  'agreements[{id}].petitionOrganization.document',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].approvalOfAgreement',
  'agreements[{id}].approvalOfAgreementAttachment',
  'agreements[{id}].eliminateViolationsNumber',
  'agreements[{id}].conclusionDate',
  'agreements[{id}].termOfExecutionAgreement',
  'agreements[{id}].eliminateViolationsAttachment',
  'agreements[{id}].applicationForConsiderationAttachment',
  'agreements[{id}].violationCorrectionProgramAttachments',
  'agreements[{id}].fioSigner',
  'agreements[{id}].titleSigner',
  'agreements[{id}].approveInfo.note',
  'agreements[{id}].approveInfo.approved',
  'agreements[{id}].approveInfo.numberDecision',
  'agreements[{id}].approveInfo.dateDecision',
  'agreements[{id}].approveInfo.whoMadeDecision',
  'agreements[{id}].approveInfo.titleSigner',
  'agreements[{id}].approveInfo.attachment',
  'agreements[{id}].terminate.terminationReasons',
  'agreements[{id}].terminate.decisionTerminationAttachment',
  'agreements[{id}].terminate.titleSigner',
  'agreements[{id}].terminate.titleSigner.label',
  'agreements[{id}].terminate.fioSigner',
  'agreements[{id}].execution.decision',
  'agreements[{id}].execution.executionDate',
  'agreements[{id}].execution.titleSigner',
  'agreements[{id}].execution.fioSigner',
  'agreements[{id}].changes[{id}].types',
  'agreements[{id}].changes[{id}].types[{id}].type',
  'agreements[{id}].changes[{id}].reasons',
  'agreements[{id}].changes[{id}].reasons[{id}]',
  'agreements[{id}].changes[{id}].attachment',
  'agreements[{id}].changes[{id}].termOfExecutionAgreement',
  'agreements[{id}].changes[{id}].updatedAgreementAttachment',
  'agreements[{id}].changes[{id}].petitionAttachment',
  'agreements[{id}].changes[{id}].titleSigner',
  'agreements[{id}].changes[{id}].fioSigner',
  'linkErpId',
  `objects[{id}].address`,
  `objects[{id}].objectType`,
  `objects[{id}].objectKind`,
  `objects[{id}].objectSubKind`,
  'organization.organizationType',
  'organization.inn',
  'inspectors',
  'inspectors[{id}].fullName',
  'inspectors[{id}].position',
  'isNeedToAddAct',
  'uavTechnologies',
  'uavTechnologies[{id}].type',
  'uavTechnologies[{id}].name',
];
